import { useEffect } from "react";
const useInterval = (callback, frequency = 10) => {
  useEffect(() => {
    const timer = setInterval(callback, frequency);
    return () => {
      clearInterval(timer);
    };
  }, [callback, frequency]);
};
export {
  useInterval
};
//# sourceMappingURL=useInterval.js.map
